import { render, staticRenderFns } from "./WarningsInline.vue?vue&type=template&id=61382023&scoped=true&"
import script from "./WarningsInline.vue?vue&type=script&lang=ts&"
export * from "./WarningsInline.vue?vue&type=script&lang=ts&"
import style0 from "./WarningsInline.vue?vue&type=style&index=0&id=61382023&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61382023",
  null
  
)

export default component.exports